<script lang="ts">
    import {beforeNavigate} from '$app/navigation';
    import {updated} from '$app/stores';
    import Dialogs from '$lib/components/Dialogs.svelte';
    import SvelteKitLoadingIndicator from '$lib/components/SvelteKitLoadingIndicator.svelte';
    import Toasts from '$lib/components/Toasts.svelte';
    import '$lib/styles/index.less';
    import {dom_ready} from '$lib/utils-browser';
    import {onMount} from 'svelte';

    onMount(() => {
        if (!window.location.hostname.endsWith('q-showcase.ru')) {
            dom_ready(() => {
                import('$lib/gy/s2').then(({yandexMetrika}) => {
                    yandexMetrika(46538133);
                });

                import('$lib/gy/s1').then(({googleAnalytics}) => {
                    googleAnalytics('UA-109256997-1');
                });

                if (new URLSearchParams(window.location.search).get('utm_source') !== 'widget') {
                    import('$lib/q-chat').then(({initQChat}) => {
                        initQChat('7815696ecbf1c96e6894b779456d330e');
                    });
                }
            });
        }
    });

    beforeNavigate(async ({willUnload, to}) => {
        await updated.check();
        if ($updated && !willUnload && to?.url) {
            location.href = to.url.href;
        }
    });
</script>

<slot />

<Toasts />
<Dialogs />
<SvelteKitLoadingIndicator />
